import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@mui/material';
import { useContext, useEffect, useMemo } from 'react';
import { SiteContext } from '../../../utils/common';
import useStyles from './PCCOccasion.styles';
import * as Yup from 'yup';
import { FormikContext, useField } from 'formik';
import RenderDesktopOccasions from './RenderDesktopOccasions';
import RenderMobileOccasions from './RenderMobileOccasions';
export const validationOccasionSchema = Yup.object().shape({
    occasion: Yup.string(),
});
const PCCOccasion = ({ currentStep, step, selectedOccasion, setIsShowDayPicker, trackPostCodeCheckerOccasion, occasionQuickLinks, showAllOccasions, setShowAllOccasions, setMatchedOccasionLinks, isPCCEditFeatureEnabled, setCurrentStep, }) => {
    var _a;
    const { occasions = [] } = useContext(SiteContext);
    const formikContext = useContext(FormikContext);
    const [, , helper] = useField('occasion');
    const renderOccasion = ({ label, occasionReminders }) => ({
        value: label,
        label,
        icon: occasionReminders === null || occasionReminders === void 0 ? void 0 : occasionReminders.occasionIcon,
        url: occasionReminders === null || occasionReminders === void 0 ? void 0 : occasionReminders.occasionCategoryUrl,
    });
    const occasionsList = useMemo(() => {
        const seenLabels = new Map();
        return occasions.reduce((acc, occasion) => {
            if (occasion.isPostcodeChecker) {
                const renderedOccasion = renderOccasion(occasion);
                if (!seenLabels.has(renderedOccasion.label)) {
                    seenLabels.set(renderedOccasion.label, renderedOccasion);
                    acc.push(renderedOccasion);
                }
            }
            return acc;
        }, []);
    }, [occasions]);
    const matchedOccasions = useMemo(() => {
        return (occasionQuickLinks !== null && occasionQuickLinks !== void 0 ? occasionQuickLinks : []).filter((quickOccasion) => occasionsList.some((allOccasion) => quickOccasion.label === allOccasion.label));
    }, [occasionQuickLinks, occasionsList]);
    useEffect(() => {
        setMatchedOccasionLinks === null || setMatchedOccasionLinks === void 0 ? void 0 : setMatchedOccasionLinks(matchedOccasions);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [matchedOccasions]);
    const displayAllOccasions = showAllOccasions || (matchedOccasions === null || matchedOccasions === void 0 ? void 0 : matchedOccasions.length) === 0 ? occasionsList : matchedOccasions === null || matchedOccasions === void 0 ? void 0 : matchedOccasions.slice(0, 4);
    const { classes } = useStyles({ occasionsCount: displayAllOccasions === null || displayAllOccasions === void 0 ? void 0 : displayAllOccasions.length });
    // Handle change without constructing a fake event
    const handleChange = (event, isFromSelectionButton) => {
        helper.setValue(event.target.value);
        setIsShowDayPicker(true);
        if (isFromSelectionButton) {
            !isPCCEditFeatureEnabled && (formikContext === null || formikContext === void 0 ? void 0 : formikContext.submitForm());
            if (isPCCEditFeatureEnabled) {
                setCurrentStep === null || setCurrentStep === void 0 ? void 0 : setCurrentStep(4);
                setShowAllOccasions === null || setShowAllOccasions === void 0 ? void 0 : setShowAllOccasions(false);
            }
        }
        else if (isPCCEditFeatureEnabled && (matchedOccasions === null || matchedOccasions === void 0 ? void 0 : matchedOccasions.length) === 0) {
            setCurrentStep === null || setCurrentStep === void 0 ? void 0 : setCurrentStep(4);
        }
        trackPostCodeCheckerOccasion === null || trackPostCodeCheckerOccasion === void 0 ? void 0 : trackPostCodeCheckerOccasion(event === null || event === void 0 ? void 0 : event.target.value);
    };
    if (currentStep !== step)
        return null;
    const shouldShowSelectDropdown = showAllOccasions || ((_a = matchedOccasions === null || matchedOccasions === void 0 ? void 0 : matchedOccasions.length) !== null && _a !== void 0 ? _a : 0) === 0;
    return (_jsxs("div", { className: classes.occasionContainer, children: [_jsx(Box, { sx: { display: { zero: 'block', md: 'none' } }, children: _jsx(RenderMobileOccasions, { shouldShowSelectDropdown: shouldShowSelectDropdown, displayAllOccasions: displayAllOccasions, matchedOccasions: matchedOccasions, showAllOccasions: showAllOccasions, selectedOccasion: selectedOccasion, handleChange: handleChange, setShowAllOccasions: setShowAllOccasions, classes: classes, occasionsList: occasionsList }) }), _jsx(Box, { sx: { display: { zero: 'none', md: 'block' } }, children: _jsx(RenderDesktopOccasions, { shouldShowSelectDropdown: shouldShowSelectDropdown, displayAllOccasions: displayAllOccasions, matchedOccasions: matchedOccasions, showAllOccasions: showAllOccasions, selectedOccasion: selectedOccasion, handleChange: handleChange, setShowAllOccasions: setShowAllOccasions, classes: classes, occasionsList: occasionsList }) })] }));
};
export default PCCOccasion;
